import PublicLayout from "sections/PublicLayout";
import TeacherDirectory from "sections/public/TeacherDirectory";
import { getTeachers } from "firestoreService";

function Teachers() {
  return (
    <PublicLayout
      eyebrow="A1 Institute"
      title="Our Teachers"
      subtitle="Qualified, experienced teachers across every subject we cover."
    >
      <TeacherDirectory fetchTeachers={getTeachers} />
    </PublicLayout>
  );
}

export default Teachers;
